import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import Select from 'components/Selectors/Select/mobile';
import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/desktop';
import Modal from 'components/ModalProvider/Modal/Modal';
import SVG from 'components/SVG';

import crossSVG from 'shared/img/cross-transparent.svg';

import GiftRequestsItem from './GiftRequestsItem';
import './GiftRequestsTable.scss';

const b = block('gifts-requests-table-desktop');

const GiftRequestsTable = ({ model }) => {
  const locale = useSelector(s => s.locale.locale);
  const { values, handlers } = model;

  const headers = [
    locale.id,
    locale.date,
    locale.username,
    locale.gift,
    locale.points2,
    locale.status,
    locale.address,
  ].map((t, i) => (
    <div className={b('table-cell')} key={i}>
      {t}
    </div>
  ));

  const items = values.items.map(t => (
    <GiftRequestsItem
      item={t}
      key={t.id}
      onChange={handlers.handleRequestChange}
      handleSetAddressModalOpen={comment => handlers.setAddressModalOpen(comment)}
    />
  ));

  const modalContent = (
    <div className={b('address')}>
      <div className={b('address-header')}>
        <div className={b('address-title')}>{locale.address}</div>
        <div className={b('address-cross')}>
          <SVG
            onClick={() => handlers.setAddressModalOpen(null)}
            className={b('address-cross-icon')}
            svgProps={{ svg: crossSVG }}
          />
        </div>
      </div>
      <div className={b('address-content')}>{values.addressModalOpen}</div>
    </div>
  );

  return (
    <article className={b()}>
      {values.addressModalOpen && (
        <Modal content={modalContent} closeFunction={() => handlers.setAddressModalOpen(null)} />
      )}
      <div className={b('header')}>
        <div className={b('header-title')}>{locale.result}:</div>
        <div className={b('header-text')}>{locale.elementsOnPage}:</div>
        <div className={b('header-select')}>
          <Select items={values.state.itemsOnPage} onChange={handlers.handleItemsOnPageChange} />
        </div>
      </div>

      <section className={b('content')}>
        <div className={b('table')}>
          <div className={b('table-header')}>{headers}</div>
          {!!items.length ? items : <div className={b('no-results')}>{locale.noResults}</div>}
        </div>

        <div className={b('paginator-wrapper')}>
          <div className={b('extra')}>
            <div className={b('extra-info')}>
              {values.count} {locale.records}
            </div>
          </div>
          <PaginatorSwitcher
            count={values.count}
            currentPage={values.state.page}
            onPageClick={handlers.handlePageChange}
            itemsOnPage={{ value: values.activeItemsOnPage }}
          />
        </div>
      </section>
    </article>
  );
};

export default GiftRequestsTable;
